import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.538 1C4.538 0.448 4.985 0 5.538 0C6.09 0 6.538 0.448 6.538 1V9.254L9.169 6.751C9.605 6.336 10.312 6.336 10.748 6.751C11.184 7.166 11.184 7.838 10.748 8.253L5.537 13L0.327 8.253C-0.109 7.838 -0.109 7.166 0.327 6.751C0.763 6.336 1.47 6.336 1.906 6.751L4.538 9.254V1ZM0 15C0 14.4477 0.4928 14 1.1 14H9.9C10.5083 14 11 14.4477 11 15C11 15.5523 10.5083 16 9.9 16H1.1C0.4928 16 0 15.5523 0 15Z",
  fill: "#2B3951"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };